/* eslint-disable */
import { URL_API_SERVICE } from '../../config';
import axios from 'utils/axios';

const token = localStorage.getItem('serviceToken');
  const options = {
    headers: {
        'Authorization': 'Bearer '+token
    }
  };

class log_versionServices {

    getAll = () => new Promise((resolve, reject) => {     
        axios.post( URL_API_SERVICE + 'log_version', { operacion:"getAll"}, this.getToken()  )
            .then((response) => {    
              resolve(response.data);            
        })
        .catch((error) => {  
            this.check_token(error);         
            reject(error);
        });
    })
    getAllByIdVersions = (id_versions) => new Promise((resolve, reject) => {     
        axios.post( URL_API_SERVICE + 'log_version', { operacion:"getAllByIdVersions", id: id_versions}, this.getToken()  )
            .then((response) => {    
              resolve(response.data);            
        })
        .catch((error) => {  
            this.check_token(error);         
            reject(error);
        });
    })
    getById = (id) => new Promise((resolve, reject) => {     
        axios.post( URL_API_SERVICE + 'log_version', { operacion:"getById", id: id}, this.getToken()  )
            .then((response) => {    
              resolve(response.data);            
        })
        .catch((error) => {  
            this.check_token(error);         
            reject(error);
        });
    })
    newLog_version = (data) => new Promise((resolve, reject) => {     
        axios.post( URL_API_SERVICE + 'log_version', { operacion:"new", data: data}, this.getToken()  )
            .then((response) => {    
              resolve(response.data);            
        })
        .catch((error) => {  
            this.check_token(error);         
            reject(error);
        });
    })
    updateById = (data) => new Promise((resolve, reject) => {     
        axios.post( URL_API_SERVICE + 'log_version', { operacion:"updateById", data: data}, this.getToken()  )
            .then((response) => {    
              resolve(response.data);            
        })
        .catch((error) => {  
            this.check_token(error);         
            reject(error);
        });
    })
    delById = (id) => new Promise((resolve, reject) => {     
        axios.post( URL_API_SERVICE + 'log_version', { operacion:"delById", id: id}, this.getToken()  )
            .then((response) => {    
              resolve(response.data);            
        })
        .catch((error) => {  
            this.check_token(error);         
            reject(error);
        });
    })
    delByIds = (ids) => new Promise((resolve, reject) => {     
        axios.post( URL_API_SERVICE + 'log_version', { operacion:"delByIds", ids: ids}, this.getToken()  )
            .then((response) => {    
              resolve(response.data);            
        })
        .catch((error) => {  
            this.check_token(error);         
            reject(error);
        });
    })
    historyLogVersion = () => new Promise((resolve, reject) => {     
        axios.post( URL_API_SERVICE + 'log_version', { operacion:"historyLogVersion"}, this.getToken()  )
            .then((response) => {    
              resolve(response.data);            
        })
        .catch((error) => {  
            this.check_token(error);         
            reject(error);
        });
    })


    getToken(){
        const token_v = localStorage.getItem('serviceToken');
        const options_v = {
          headers: {
              'Authorization': 'Bearer '+token_v
          }
        };
        return options_v;
    }
    check_token(error){      
        //Check if token expired and end session
        if (error.error==="jwt expired"){
          this.setSession(null);
          localStorage.removeItem('serviceToken');
          delete axios.defaults.headers.common.Authorization;
          window.location.reload();
        }
    }
  
    setSession = (accessToken) => {
        if (accessToken) {
            localStorage.setItem('serviceToken', accessToken);
            axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
        } else {
            localStorage.removeItem('serviceToken');
            delete axios.defaults.headers.common.Authorization;
        }
    }

}


const log_versionService = new log_versionServices();

export default log_versionService;
